<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nzCollapsible
    nzWidth="180px"
    nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
  >
    <div class="sidebar-logo">
      <img
        *ngIf="!isCollapsed"
        class="home-logo"
        src="../../../assets/img/header-logo-white.png"
      />
    </div>

    <ul
      nz-menu
      nzTheme="light"
      nzMode="inline"
      [nzInlineCollapsed]="isCollapsed"
    >
      <li
        nz-submenu
        [(nzOpen)]="openMap.sub3"
        (nzOpenChange)="openHandler('sub3')"
        nzTitle="{{ 'navbar.title' | translate }}"
        nzIcon="dashboard"
        *ngIf="
          isWithPermissions('glucose') ||
          isWithPermissions('medicalreport') ||
          isWithPermissions('organizationsystem')
        "
      >
        <ul>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="
              isWithPermissions('glucose') ||
              isWithPermissions('organizationsystem')
            "
          >
            <a routerLink="blood">{{ "navbar.home" | translate }}</a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="
              isWithPermissions('medicalreport') ||
              isWithPermissions('organizationsystem')
            "
          >
            <a routerLink="medicalreport">{{
              "medicalreports.medicalreport" | translate
            }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub5"
        (nzOpenChange)="openHandler('sub5')"
        nzTitle="{{ 'navbar.food' | translate }}"
        nzIcon="unordered-list"
        *ngIf="isWithPermissions('foods') || isWithPermissions('foodsunit')"
      >
        <ul>
          <li nz-menu-item *ngIf="isWithPermissions('foods')">
            <a routerLink="food" nzMatchRouter>{{
              "navbar.food" | translate
            }}</a>
          </li>
          <li nz-menu-item *ngIf="isWithPermissions('foodsunit')">
            <a routerLink="food/unit">{{ "navbar.unit" | translate }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub6"
        (nzOpenChange)="openHandler('sub6')"
        nzTitle="{{ 'navbar.drug' | translate }}"
        nzIcon="unordered-list"
        *ngIf="isWithPermissions('drugs') || isWithPermissions('drugsunit')"
      >
        <ul>
          <li nz-menu-item *ngIf="isWithPermissions('drugs')">
            <a routerLink="drug" nzMatchRouter>{{
              "navbar.drug" | translate
            }}</a>
          </li>
          <li nz-menu-item *ngIf="isWithPermissions('drugsunit')">
            <a routerLink="drug/unit">{{ "navbar.unit" | translate }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub7"
        (nzOpenChange)="openHandler('sub7')"
        nzTitle="{{ 'navbar.sport' | translate }}"
        nzIcon="unordered-list"
        *ngIf="isWithPermissions('sports') || isWithPermissions('sportsunit')"
      >
        <ul>
          <li nz-menu-item *ngIf="isWithPermissions('sports')">
            <a routerLink="sport" nzMatchRouter>{{
              "navbar.sport" | translate
            }}</a>
          </li>
          <li nz-menu-item *ngIf="isWithPermissions('sportsunit')">
            <a routerLink="sport/unit">{{ "navbar.unit" | translate }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub4"
        (nzOpenChange)="openHandler('sub4')"
        nzTitle="{{ 'navbar.management' | translate }}"
        nzIcon="global"
        *ngIf="
          isWithPermissions('usermanagement') ||
          isWithPermissions('updatepassword')
        "
      >
        <ul>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('usermanagement')"
          >
            <a routerLink="users">{{ "navbar.users" | translate }}</a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('updatepassword')"
          >
            <a routerLink="change-passwd">{{
              "navbar.chg-pass" | translate
            }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub8"
        (nzOpenChange)="openHandler('sub8')"
        nzTitle="{{ 'permissions.permission' | translate }}"
        nzIcon="global"
        *ngIf="
          isWithPermissions('rolessetting') ||
          isWithPermissions('userrightsmanagement')
        "
      >
        <ul>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('rolessetting')"
          >
            <a routerLink="role">{{ "permissions.role" | translate }}</a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('userrightsmanagement')"
          >
            <a routerLink="authority">{{
              "permissions.authority" | translate
            }}</a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        [(nzOpen)]="openMap.sub9"
        (nzOpenChange)="openHandler('sub9')"
        nzTitle="{{ 'navbar.organization' | translate }}"
        nzIcon="global"
        *ngIf="
          isWithPermissions('organizationmanagement') ||
          isWithPermissions('departmentmanagement')
        "
      >
        <ul>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('organizationmanagement')"
          >
            <a routerLink="organization">{{
              "navbar.organization" | translate
            }}</a>
          </li>
          <li
            nz-menu-item
            nzMatchRouter
            *ngIf="isWithPermissions('departmentmanagement')"
          >
            <a routerLink="department">{{ "navbar.department" | translate }}</a>
          </li>
          <!-- <li nz-menu-item nzMatchRouter *ngIf="isWithPermissions('globalsystem')">
            <a routerLink="organization-administrator">{{'navbar.org-admin' | translate}}</a>
          </li> -->
        </ul>
      </li>
    </ul>
  </nz-sider>

  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i
            class="trigger"
            nz-icon
            [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
          ></i>
        </span>

        <div class="div-flex" *ngIf="auth.user$ | async as user">
          <div>
            <div *ngIf="isGlobalAdmin">{{ "roles.sysAdmin" | translate }}</div>
            <div *ngIf="isOrgAdmin" class="organ-admin">
              <div *ngFor="let item of organizations;let i = index">
                <span>{{item.name}}</span>
                <span *ngIf="i < organizations.length-1">,</span>
              </div>
              <span>{{ "roles.orgAdmin" | translate }}</span>
            </div>
            <!-- <div>组织管理员</div> -->
            <div style="line-height: 20px">{{ user.email }}</div>
          </div>

          <!-- <nz-divider nzType="vertical"></nz-divider> -->

          <span class="header-user">
            <nz-select
              class="organ"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder=""
              [(ngModel)]="searchOrigan"
              (ngModelChange)="organModelChange($event)"
              *ngIf="!isAdmin && !isAppUserCms"
            >
              <nz-option
                *ngFor="let organ of organizations"
                [nzLabel]="organ.name"
                [nzValue]="organ._id"
              ></nz-option>
            </nz-select>

            <a nz-dropdown [nzDropdownMenu]="menu">
              <img [src]="user.picture" />
              <i nz-icon nzType="down"></i>
            </a>

            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <!-- <li nz-menu-item (click)="logout()">{{user.nickname}}</li> -->
                <li nz-menu-item (click)="logout()">
                  {{ "navbar.signOut" | translate }}
                </li>
              </ul>
            </nz-dropdown-menu>
          </span>

          <span class="lang-switch"><change-language></change-language></span>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>

  <nz-modal
    [(nzVisible)]="isVisible"
    nzTitle="{{ 'navbar.signOut' | translate }}"
    [nzOkLoading]="isOkLoading"
    nzClosable="false"
    nzMaskClosable="false"
    (nzOnOk)="handleOk()"
    [nzCancelText]="null"
  >
    <ng-container *nzModalContent>
      <nz-select
        class="organ-first"
        nzShowSearch
        nzAllowClear
        nzPlaceHolder=""
        [(ngModel)]="organAdmin"
      >
        <nz-option
          *ngFor="let organ of organizations"
          [nzLabel]="organ.name"
          [nzValue]="organ._id"
        ></nz-option>
      </nz-select>
    </ng-container>
  </nz-modal>
</nz-layout>
